import { go, sel } from 'fxjs/es';
import { createCanvasElement, makeCanvasByUrl } from '../../../../../Canvas/S/util.js';
import { BpOptionKeyRingConstantS } from '../../../../../BpOption/KeyRing/S/Constant/module/BpOptionKeyRingConstantS.js';
import { NewMakerBaseProductsKeyRingF } from '../../../../../NewMaker/BaseProducts/KeyRing/F/Function/module/NewMakerBaseProductsKeyRingF.js';
import { NewMakerCvObjectUtilF } from '../../../../../NewMaker/CvObject/Util/F/Function/module/NewMakerCvObjectUtilF.js';
import { BpOptionKeyRingS } from '../../../../../BpOption/KeyRing/S/Function/module/BpOptionKeyRingS.js';
import { makeDefaultCvImageAttrs } from '../../../../../Maker/F/CvImage/fs.js';

async function makeBiggerHoleFiles(keyring_design_canvas, hook_position_ratio, real_size) {
  const hole_cm = 0.4;
  const cm = real_size ? hole_cm * (keyring_design_canvas.width / real_size) : hole_cm;
  const ctx = keyring_design_canvas.getContext('2d');
  const x = hook_position_ratio.x * keyring_design_canvas.width;
  const y = hook_position_ratio.y * keyring_design_canvas.height;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.arc(x, y, (cm / 2 / 2.54) * 300, 0, 2 * Math.PI);
  ctx.fill();
  return new Promise((res) => {
    keyring_design_canvas.toBlob(function (blob) {
      // Create a file object
      res({
        file: new File([blob], keyring_design_canvas.name, { type: 'image/png' }),
        width: keyring_design_canvas.width,
      });
    });
  });
}
async function setThumbnailAndPrice2({
  fitted_size,
  cutting_line_svg_file,
  printable_png_file,
  thumbnail_png_file,
  product,
  hook_position_ratio,
}) {
  const cutting_line_svg_str = await new Promise((resolve, reject) => {
    const file_reader = new FileReader();
    file_reader.addEventListener('error', (event) => {
      console.error(event);
      reject(new Error('cutting_line_svg_file 을 읽을 수 없습니다.'));
    });
    file_reader.addEventListener('load', () => resolve(file_reader.result));
    file_reader.readAsText(cutting_line_svg_file);
  });

  const printable_data_url = await new Promise((resolve, reject) => {
    const file_reader = new FileReader();
    file_reader.addEventListener('error', (event) => {
      console.error(event);
      reject(new Error('printable_png_file 을 읽을 수 없습니다.'));
    });
    file_reader.addEventListener('load', () => resolve(file_reader.result));
    file_reader.readAsDataURL(printable_png_file);
  });
  const thumbnail_data_url = thumbnail_png_file
    ? await new Promise((resolve, reject) => {
        const file_reader = new FileReader();
        file_reader.addEventListener('error', (event) => {
          console.error(event);
          reject(new Error('printable_png_file 을 읽을 수 없습니다.'));
        });
        file_reader.addEventListener('load', () => resolve(file_reader.result));
        file_reader.readAsDataURL(thumbnail_png_file);
      })
    : await (() => {
        return go(printable_data_url, async (printable_data_url) => {
          const canvas = await makeCanvasByUrl(printable_data_url);
          const size = 2000;
          const c = createCanvasElement(
            canvas.width > canvas.height
              ? { width: size, height: (canvas.height * size) / canvas.width }
              : { width: (canvas.width * size) / canvas.height, height: size },
          );
          c.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, c.width, c.height);
          return c.toDataURL();
        });
      })();
  const selected_option_group = product._.selected_option_group;
  const material = selected_option_group.bp_option_ids.includes(
    BpOptionKeyRingConstantS.KEYRING_MATERIAL_GL_BP_OPTION_ID,
  )
    ? 'gl'
    : selected_option_group.bp_option_ids.includes(BpOptionKeyRingConstantS.KEYRING_MATERIAL_AU_BP_OPTION_ID)
    ? 'au'
    : '';

  const is_free = selected_option_group.bp_option_ids.includes(BpOptionKeyRingConstantS.FREE_BP_OPTION_ID);
  const ratio =
    (await go(makeCanvasByUrl(thumbnail_data_url), sel('width'))) /
    (await go(makeCanvasByUrl(printable_data_url), sel('width')));
  const { canvas, coord, real_size } = await NewMakerBaseProductsKeyRingF.svgAndPngToCvImages({
    svg_data_url: cutting_line_svg_str,
    png_data_url: thumbnail_data_url,
    hook_position_ratio,
    material,
    ratio,
  });
  const main_cv_img = await go(
    canvas,
    (canvas) => {
      return NewMakerCvObjectUtilF.makeImageObjForCvObj(canvas.toDataURL());
    },
    (obj) => {
      obj.width_cm = ((obj.width / 300) * 2.54) / ratio;
      obj.height_cm = ((obj.height / 300) * 2.54) / ratio;
      return obj;
    },
  );
  if (is_free) {
    fitted_size.width = Math.min(real_size.width, 100);
    fitted_size.height = Math.min(real_size.height, 100);
  }
  const price = BpOptionKeyRingS.makePrice(fitted_size);
  const cv_obj = makeDefaultCvImageAttrs(main_cv_img);
  cv_obj._data.hole_position = coord;
  cv_obj._data.fitted_size = fitted_size;
  cv_obj.price = price.price;
  cv_obj.price_en = price.price_en;
  cv_obj.price_jp = price.price_jp;
  const px_per_1cm = product.product_faces2.value[0].size_faces[0].px_per_1cm;
  const hole_position = product.product_faces2.value[0].size_faces[0].print.etc_meta.hole_position;
  if (!hole_position) return;
  const width = cv_obj._data.image_width_cm * px_per_1cm;
  cv_obj.scaleToWidth(width);
  let top = hole_position.y;
  let left = hole_position.x;
  top -= cv_obj._data.hole_position.y * (cv_obj.height * cv_obj.scaleY);
  left -= cv_obj._data.hole_position.x * width;
  top += (G.mp.maker.CANVAS_HEIGHT - G.mp.maker.CANVAS_WIDTH) / 2;
  cv_obj.set({ top, left });
}

export const keyringProcessByFile2 = async ({
  product,
  cutting_line_svg_file,
  printable_canvas,
  thumbnail_canvas,
  hook_position_ratio,
  // original_svg_file_name,
}) => {
  const { file: printable_png_file, width: real_size } = await makeBiggerHoleFiles(
    printable_canvas,
    hook_position_ratio,
  );
  const { file: thumbnail_png_file } = await makeBiggerHoleFiles(
    thumbnail_canvas,
    hook_position_ratio,
    real_size,
  );
  product._.svg_product_materials = [
    {
      // original_svg_file_url,
      printable_file: printable_png_file,
      original_cutting_line_svg_file: cutting_line_svg_file,
    },
  ];
  await setThumbnailAndPrice2({
    fitted_size: {},
    cutting_line_svg_file,
    printable_png_file,
    thumbnail_png_file,
    product,
    hook_position_ratio,
  });
};
